import React, { useContext, useEffect } from 'react'
import { ReportingContext } from '../../../wrappers/ReportingContext'
import ReportTable from '../../../elem/reporting/shared/table/ReportTable'
import { Link } from 'react-router-dom'
import LoadingSpinner from '../../../elem/LoadingSpinner'
import { FaDownload, FaGripHorizontal, FaInfoCircle } from 'react-icons/fa'

const ReportDataTable = ({
    reportId,
    loading,
    loadingExport,
    data,
    onClickExport,
    onClickRun,
    updateQueryParameters,
    queryParameters,
}) => {
    return (
        <div className="section viewReportDataTableWrapper">
            <div className="columns">
                <div className="column is-12">
                    <div className="content is-small">
                        <nav className="level">
                            <div className="level-right">
                                <div className="level-item">
                                    <p className="subtitle is-4">Report Data</p>
                                </div>
                            </div>
                            <div className="level-left">
                                <div className="level-item buttons">
                                    <Link
                                        to="/files/WYDEQ_SWM_FieldDescriptors.pdf"
                                        target="_blank"
                                        className="button is-info"
                                    >
                                        <span className="icon is-small">
                                            <FaInfoCircle />
                                        </span>
                                        <span>Field Descriptors</span>
                                    </Link>
                                    <button
                                        className={`button is-info ${
                                            loadingExport ? `is-loading` : ``
                                        }`}
                                        onClick={onClickExport}
                                        disabled={loadingExport}
                                    >
                                        <span className="icon is-small">
                                            <FaDownload />
                                        </span>
                                        <span>Download Data</span>
                                    </button>
                                </div>
                            </div>
                        </nav>
                        {data && (
                            <ReportTable
                                data={data}
                                loading={loading}
                                updateQueryParameters={updateQueryParameters}
                                queryParameters={queryParameters}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

const ReportInformationHeader = () => {
    const { report } = useContext(ReportingContext)
    return (
        <div className="columns viewReportInformationHeaderWrapper">
            <div className="column is-2 backButton">
                <p className="is-size-6 ">
                    <Link to="/admin/reports">
                        <span className="icon">
                            <i className="fa fa-chevron-left" />
                        </span>
                        Return to Report List
                    </Link>
                </p>
            </div>
            <div className="column is-8 has-text-centered">
                <p className="is-size-5">
                    <strong>Report ID: </strong> {report.ReportId}
                    <span> | </span>
                    <strong>Report Name: </strong> {report.ReportName}
                </p>
            </div>
            <div className="column is-2"></div>
        </div>
    )
}

const ViewReport = () => {
    const {
        loading,
        report,
        reportTableData,
        runReport,
        exportReport,
        reportId,
        updateQueryParameters,
        queryParameters,
        loadingExport,
    } = useContext(ReportingContext)

    useEffect(() => {
        runReport()
    }, [report, reportId, runReport])

    return (
        <div className="viewReportContainer">
            {report && <ReportInformationHeader />}
            {(loading || !reportTableData) && <LoadingSpinner />}
            {report && (
                <ReportDataTable
                    loading={loading}
                    loadingExport={loadingExport}
                    data={reportTableData}
                    reportId={reportId}
                    onClickRun={runReport}
                    onClickExport={exportReport}
                    updateQueryParameters={updateQueryParameters}
                    queryParameters={queryParameters}
                />
            )}
        </div>
    )
}

export default ViewReport
